const SLUG_PATTERN = /^[a-z]{3}-[a-z]{3}-[a-z]{3}$/i;
const ROOM_PATH_PATTERN = /(?:^|\/)r\/([^/?#]+)/;

const slugFromPath = (path: string): string | null => {
  const match = ROOM_PATH_PATTERN.exec(path);
  if (!match?.[1]) {
    return null;
  }
  let slug: string;
  try {
    slug = decodeURIComponent(match[1]);
  } catch {
    return null;
  }
  return SLUG_PATTERN.test(slug) ? slug.toLowerCase() : null;
};

const asUrl = (value: string): URL | null => {
  try {
    return new URL(/^[a-z][a-z0-9+.-]*:\/\//i.test(value) ? value : `https://${value}`);
  } catch {
    return null;
  }
};

export const slugFromJoinLink = (input: string): string | null => {
  const value = input.trim();
  if (!value) {
    return null;
  }
  if (SLUG_PATTERN.test(value)) {
    return value.toLowerCase();
  }
  if (value.startsWith("/")) {
    return slugFromPath(value);
  }
  const url = asUrl(value);
  return url ? slugFromPath(url.pathname) : slugFromPath(value);
};
